// PrivacyPolicy.jsx
import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, Form, Input, Row, Col, Switch, Checkbox, InputNumber, DatePicker, TimePicker , Select} from 'antd';
// import { Form, Input, Switch, Select } from 'antd';

import { BreathAPIs } from '../../APIs/BreathAPIs';
import { toast } from 'react-toastify';
import { ButtonCustom } from '../../BootstrapComponents/ButtonCustom';
import styles from './styles.module.css'
import { Label } from 'recharts';



const AddCharger = ({ modalVisible, closeModal, submitFeedback, location }) => {
    console.log('Location data in AddCharger: ',location);
    const handleCancel = () => {
        form.resetFields();
            setChargerFormData({
                protocol: "",
                chargerTag: "",
                isSimulator: false,
                // connector: {
                //     name: "",
                //     active: true,
                //     format: "",
                //     type: "",
                //     power_type: "",
                //     power: "",
                // },
                connector: [],
                rate: {
                    currency: "",
                    price_components: {
                        price_type: '',
                        price: 0,
                        tax: 0,
                        grace_period: 0,
                    }
                },
                manufacturer:"",
                // nonReservable:false,
                connectionServer:"CSMS_BREATHE",
                public:true,
                // unlistCharger:false

            })
            setCount(0);
            setExpand(null);
        closeModal();
    };

    const [chargerCount, setChargerCount] = useState(1);
    const [count, setCount] = useState(0);
    const [connectorDetails, setConnectorDetails] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [expand, setExpand] = useState();
    const [chargerFormData, setChargerFormData] = useState({
        protocol: "",
        chargerTag: "",
        isSimulator: false,
        // connector: {
        //     name: "",
        //     active: true,
        //     format: "",
        //     type: "",
        //     power_type: "",
        //     power: "",
        // },
        connector: [],
        rate: {
            currency: "",
            price_components: {
                price_type: '',
                price: 0,
                tax: 0,
                grace_period: 0,
            }
        },
        manufacturer:"",
        // nonReservable:false,
        connectionServer:"CSMS_BREATHE",
        public:true,
        // unlistCharger:false

    });

    const handleConnectorChange = (index, field, value) => {
            setChargerFormData(prev => {
                const updatedConnectors = [...prev.connector];

                // Ensure connector at index exists
                updatedConnectors[index] = {
                    ...updatedConnectors[index],
                    [field]: value
                };

                return {
                    ...prev,
                    connector: updatedConnectors
                };
            });
        };

    useEffect(() => {

        if (chargerFormData.connector.length === 0) return;

        setChargerFormData(prev => {
            const updatedConnectors = prev.connector.map(connector => ({
            ...connector,
            name: prev.chargerTag
            }));
            return { ...prev, connector: updatedConnectors };
        });
        }, [chargerFormData.chargerTag]);


    const { Option } = Select;
    const [form] = Form.useForm();
    const chargerSubmit = async () => {
        const formattedData = {
            location: location,
            protocol: chargerFormData.protocol,
            chargerTag: chargerFormData.chargerTag,
            isSimulator: chargerFormData.isSimulator,
            csmsLocation: location.csmsBreatheID,
            edrvLocation: location.edrvID,
            connector: chargerFormData.connector,
            rate: {
                currency: chargerFormData.rate.currency,
                price_components: {
                    price_type: chargerFormData.rate.price_components.price_type,
                    price: chargerFormData.rate.price_components.price,
                    tax: chargerFormData.rate.price_components.tax,
                    grace_period: chargerFormData.rate.price_components.grace_period,
                }
            },
            manufacturer: chargerFormData.manufacturer,
            // nonReservable:chargerFormData.nonReservable,
            connectionServer:chargerFormData.connectionServer
           
        };
        setIsSubmitting(true);
        try {
            console.log('Charger data before submitting: ',formattedData);
            let res;
            let chargerNumber = formattedData.chargerTag.split(" ")[formattedData.chargerTag.split(" ").length - 1];
                console.log("Charger number before", chargerNumber);
                chargerNumber = parseInt(chargerNumber)
                console.log("Loop end",parseInt(chargerCount) + parseInt(chargerNumber) - 1)
            for(let i=chargerNumber;i<=(parseInt(chargerCount) + parseInt(chargerNumber) - 1);i++){
                console.log("Charger number", chargerNumber);
                formattedData.chargerTag = (String(Math.abs(i)).length === 1) 
                ? formattedData.chargerTag.split(' ')[0] + " " + "0" + i 
                : formattedData.chargerTag.split(' ')[0] + " "+ i;
                res = await BreathAPIs.addCharger(formattedData);
            }
            
            setIsSubmitting(false);
            form.resetFields();
            setChargerFormData({
                protocol: "",
                chargerTag: "",
                isSimulator: false,
                // connector: {
                //     name: "",
                //     active: true,
                //     format: "",
                //     type: "",
                //     power_type: "",
                //     power: "",
                // },
                connector: [],
                rate: {
                    currency: "",
                    price_components: {
                        price_type: '',
                        price: 0,
                        tax: 0,
                        grace_period: 0,
                    }
                },
                manufacturer:"",
                // nonReservable:false,
                connectionServer:"CSMS_BREATHE",
                public:true,
                // unlistCharger:false

            })
            setCount(0);
            setExpand(null);
            // form.resetFields();
            submitFeedback(res.data.message);
            closeModal();
        } catch (error) {
            toast.error('Error adding charger.');
            setIsSubmitting(false);
        }
    };

    const handleConnectorAddition = () => {

    }

    return (
        <Modal
            title="Add Charger"
            open={modalVisible}
            onCancel={handleCancel}
            footer={null}
            width={window.innerWidth <= 768 ? "100%" : "50%"}
        >

            <Form form={form} onFinish={chargerSubmit} layout={'vertical'} id='locationForm'>
                <div className="row">

                    <div className="col-md-6">

                        <Form.Item label="Charger Tag" name="chargerTag" rules={[{ required: true, message: "Please input charger tag" }]}>
                            <Input value={chargerFormData.chargerTag} onChange={e => setChargerFormData(prev => ({ ...prev, chargerTag: e.target.value }))} placeholder="Enter charger tag" />
                        </Form.Item>

                        <Form.Item label="Currency" name="currency" rules={[{ required: true, message: "Please select currency" }]}>
                            <Select value={chargerFormData.rate.currency} onChange={value => setChargerFormData(prev => ({ ...prev, rate: { ...prev.rate, currency: value } }))} placeholder="Select currency">
                                <Option value="USD">USD</Option>
                            </Select>
                        </Form.Item>

                        <Form.Item label="Price type" name="price_type" rules={[{ required: true, message: "Please input price type" }]}>
                            {/* <Input value={chargerFormData.rate.price_components.price_type} onChange={e => setChargerFormData(prev => ({ ...prev, rate: { ...prev.rate, price_components: { ...prev.rate.price_components, price_type: e.target.value } } }))} placeholder="Enter price type" /> */}
                            <Select value={chargerFormData.rate.price_components.price_type} onChange={value => setChargerFormData(prev => ({ ...prev, rate: { ...prev.rate, price_components: { ...prev.rate.price_components, price_type: value } } }))}  placeholder="Select power type">  
                                <Option value="FLAT">FLAT</Option>
                                <Option value="ENERGY">ENERGY</Option>
                                <Option value="TIME">TIME</Option>
                            </Select>
                        
                        </Form.Item>

                        <Form.Item label="Price" name="price" rules={[{ required: true, message: "Please input price" }]}>
                            <Input type='number' value={chargerFormData.rate.price_components.price} onChange={e => setChargerFormData(prev => ({ ...prev, rate: { ...prev.rate, price_components: { ...prev.rate.price_components, price: e.target.value } } }))} placeholder="0.4" />
                        </Form.Item>

                        {/* <Form.Item label="Connection Server" name="connectionServer" rules={[{ required: true, message: "Please input Connection Server" }]}>
                            <Input value={chargerFormData.connectionServer} onChange={e => setChargerFormData(prev => ({ ...prev, connectionServer: e.target.value }))} placeholder="Enter connection server" />
                        </Form.Item> */}

                        {/* <Form.Item label="Unlist Charger"  >
                            <Switch checked={chargerFormData.unlistCharger} onChange={checked => setChargerFormData(prev => ({ ...prev, unlistCharger: checked }))} />
                        </Form.Item> */}

                    </div>
                     <div className="col-md-6">
                        
                        
                        {/* <Form.Item label="Rate" name="rate" rules={[{ required: true, message: "Please input rate" }]}>
                            <Input type='number' value={chargerFormData.connector.rate} onChange={e => setChargerFormData(prev => ({ ...prev, connector: { ...prev.connector, rate: e.target.value } }))} placeholder="Enter rate" />
                        </Form.Item> */}

                        <Form.Item label="Protocol" name="protocol" rules={[{ required: true, message: "Please select protocol" }]}>
                            <Select value={chargerFormData.protocol} onChange={value => setChargerFormData(prev => ({ ...prev, protocol: value }))} placeholder="Select protocol">
                                <Option value="ocpp1.6">ocpp1.6</Option>
                                <Option value="ocpp2.0.1">ocpp2.0.1</Option>
                            </Select>
                        </Form.Item> 

                        <Form.Item label="Manufacturer" name="manufacturer" >
                        <Select
                        placeholder="Select Manufacturer"
                        onChange={(selectedValue) =>  setChargerFormData(prev => ({ ...prev, manufacturer:selectedValue }))}
                        >
                        <Option value="Wallbox-A3Z8Q4T65Y">Wallbox</Option>
                        <Option value="Positive-F5C1G7K38N">Positive</Option>
                        <Option value="Autel">Autel</Option>
                        </Select>
                        </Form.Item>
                        <Form.Item label="TAX" name="tax" rules={[{ required: true, message: "Please input tax" }]}>
                            <Input type='number' value={chargerFormData.rate.price_components.tax} onChange={e => setChargerFormData(prev => ({ ...prev, rate: { ...prev.rate, price_components: { ...prev.rate.price_components, tax: e.target.value } } }))} placeholder="0.1" />
                        </Form.Item>

                        <Form.Item label="Grace period" name="grace_period" rules={[{ required: true, message: "Please input grace_period" }]}>
                            <Input type='number' value={chargerFormData.rate.price_components.grace_period} onChange={e => setChargerFormData(prev => ({ ...prev, rate: { ...prev.rate, price_components: { ...prev.rate.price_components, grace_period: e.target.value } } }))} placeholder="0.0" />
                        </Form.Item>
                        

                    </div>
                    <Form.Item label="Connection Server"  rules={[{ required: true, message: "Please input Connection Server" }]}>
                            
                        <Select value={chargerFormData.connectionServer}   onChange={(value) => setChargerFormData(prev => ({ ...prev, connectionServer: value }))}   placeholder="Enter connection server">  
                                <Option value="CSMS_BREATHE">CSMS_BREATHE</Option>
                                <Option value="EDRV">EDRV</Option>
                            </Select>
                            
                        </Form.Item>
                    <div className={styles.switchContainer}>
                        <Form.Item label="Is Simulator" name="isSimulator" valuePropName="checked">
                            <Switch checked={chargerFormData.isSimulator} onChange={checked => setChargerFormData(prev => ({ ...prev, isSimulator: checked }))} />
                        </Form.Item>
                        <Form.Item label="Public"  valuePropName="checked">
                            <Switch checked={chargerFormData.public} onChange={checked => setChargerFormData(prev => ({ ...prev, public: checked }))} />
                        </Form.Item>
                         {/* <Form.Item label="Active" name="active">
                            <Switch checked={chargerFormData.connector.active} onChange={checked => setChargerFormData(prev => ({ ...prev, connector: { ...prev.connector, active: checked } }))} />
                        </Form.Item> */}
                    </div>
                    <div className={styles.counter}>
                        Number of Connectors:
                        <button type='button' className={styles.counterButton}
                            onClick={() => {
                                setCount(prevCount => {
                                const newCount = prevCount - 1;
                                if (newCount >= 0) {
                                    setChargerFormData(prev => ({
                                    ...prev,
                                    connector: prev.connector.slice(0, newCount) // Remove last connector
                                    }));
                                }
                                return newCount;
                                });
                            }}

                            disabled={count <= 0}
                        >-</button>
                        {count}
                        <button type="button" className={styles.counterButton}
                            onClick={() => {
                                setCount(prevCount => {
                                const newCount = prevCount + 1;

                                setChargerFormData(prev => ({
                                    ...prev,
                                    connector: [
                                    ...prev.connector,
                                    {
                                        name: prev.chargerTag,  
                                        active: false,
                                        format: "",
                                        type: "",
                                        power_type: "",
                                        power: "",
                                        nonReservable: false,
                                    }
                                    ]
                                }));

                                return newCount;
                                });
                            }}
                        >+</button>
                    </div>
                    {
                        Array.from({ length: count }).map((_, index) => (
                            <div
                                className={styles.connectorDetails}
                                key={index}
                                onClick={() => {
                                    setExpand(expand === index ? null : index);
                                }}
                            >
                                Add Connector Details <span>+</span>
                                {
                                    expand === index && (
                                        <div className={styles.connectorInfo}
                                        onClick={e => e.stopPropagation()}  // Prevent click from propagating to parent div
                                        >
                                            Details for Connector {index + 1}
                                            <Form.Item label="Connector Name" rules={[{ required: true, message: "Please input connector name" }]}>
                                                <Input onClick={e => e.stopPropagation()} disabled={true} value={chargerFormData.connector[index]?.name || ""} placeholder="Enter connector name" />
                                            </Form.Item>

                                            <Form.Item label="Format" rules={[{ required: true, message: "Please select format" }]}>
                                                <Select onClick={e => e.stopPropagation()} value={chargerFormData.connector[index]?.format} onChange={(value) => handleConnectorChange(index, 'format', value)} placeholder="Select format">
                                                    <Option value="Socket">Socket</Option>
                                                    <Option value="Cable">Cable</Option>
                                                </Select>
                                            </Form.Item>

                                            <Form.Item label="Type" rules={[{ required: true, message: "Please select type" }]}>
                                                <Select onClick={e => e.stopPropagation()} value={chargerFormData.connector[index]?.type} onChange={(value) => handleConnectorChange(index, 'type', value)} placeholder="Select type">
                                                    <Option value="Type 2">Type 2</Option>
                                                    <Option value="J1772">J1772</Option>
                                                    <Option value="CCS1">CCS1</Option>
                                                    <Option value="NACS">NACS</Option>
                                                    <Option value="CCS2">CCS2</Option>
                                                    <Option value="CHAdeMO">CHAdeMO</Option>
                                                </Select>
                                            </Form.Item>

                                            <Form.Item label="Power type" rules={[{ required: true, message: "Please select power type" }]}>
                                                <Select onClick={e => e.stopPropagation()} value={chargerFormData.connector[index]?.power_type} onChange={(value) => handleConnectorChange(index, 'power_type', value)} placeholder="Select power type">
                                                    <Option value="AC Single Phase">AC Single Phase</Option>
                                                    <Option value="AC Three Phase">AC Three Phase</Option>
                                                    <Option value="DC">DC</Option>
                                                </Select>
                                            </Form.Item>

                                             <Form.Item label="Power" rules={[{ required: true, message: "Please input power" }]}>
                                                <Input onClick={e => e.stopPropagation()} type='number' value={chargerFormData.connector[index]?.power} onChange={e => handleConnectorChange(index, 'power', e.target.value)} placeholder="11.1" />
                                            </Form.Item>

                                            <Form.Item label="Active">
                                                <Switch
                                                    checked={chargerFormData.connector[index]?.active}
                                                    onChange={(checked) => handleConnectorChange(index, 'active', checked)}
                                                />
                                            </Form.Item>

                                             <Form.Item label="NonReservable" >
                                                <Switch checked={chargerFormData.connector[index]?.nonReservable} onChange={checked => handleConnectorChange(index, 'nonReservable', checked)} />
                                            </Form.Item>


                                        </div>
                                    )
                                }

                            </div>
                        ))
                    }



                    <div className="col-md-12">
                        <div className="row">
                            <div className={`col-md-12 ${styles["submitBtnContainer"]}`}>
                                <Form.Item label="No of Chargers">
                                    
                                    <Input type= "number" value = {chargerCount} onChange={e => {setChargerCount(e.target.value); console.log("Charger count", e.target.value)}}></Input>
                                </Form.Item>
                                <Form.Item style={{ textAlign: 'right' }}>
                                    <ButtonCustom isLoading={isSubmitting} text={isSubmitting ? 'Adding...' : 'Add Charger'} type='submit' />
                                </Form.Item>
                            </div>
                        </div>
                    </div>
                </div>
            </Form>


        </Modal>
    );
};


export default AddCharger;
